import { useMutation } from 'urql';
import { v4 } from 'uuid';
import { graphql } from '@/gql/graphql';

const GenerateImageUploadUrls = graphql(/* GraphQL */ `
  mutation GenerateImageUploadUrls($requestId: uuid!, $count: Int!) {
    generateImageUploadUrls(requestId: $requestId, count: $count) {
      id
      uploadURL
    }
  }
`);

export default function useGenerateImageUploadUrls() {
  const [, mutation] = useMutation(GenerateImageUploadUrls);

  return (count: number) => mutation({ requestId: v4(), count });
}
